var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 50,
    viewBox: "0 0 169 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 167.25,
    height: 48.5,
    rx: 6.5,
    fill: "black",
    stroke: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1683 27.1901C82.2283 27.1901 79.832 29.4251 79.832 32.5063C79.832 35.5676 82.2283 37.8226 85.1683 37.8226C88.1083 37.8226 90.5045 35.5676 90.5045 32.5063C90.5045 29.4251 88.1083 27.1901 85.1683 27.1901ZM85.1683 35.7276C83.557 35.7276 82.167 34.3988 82.167 32.5051C82.167 30.5926 83.557 29.2826 85.1683 29.2826C86.7795 29.2826 88.1683 30.5913 88.1683 32.5051C88.1683 34.3988 86.7795 35.7276 85.1683 35.7276ZM73.527 27.1901C70.587 27.1901 68.1908 29.4251 68.1908 32.5063C68.1908 35.5676 70.587 37.8226 73.527 37.8226C76.467 37.8226 78.8633 35.5676 78.8633 32.5063C78.8633 29.4251 76.467 27.1901 73.527 27.1901ZM73.527 35.7276C71.9158 35.7276 70.5258 34.3988 70.5258 32.5051C70.5258 30.5926 71.9158 29.2826 73.527 29.2826C75.1383 29.2826 76.527 30.5913 76.527 32.5051C76.527 34.3988 75.137 35.7276 73.527 35.7276ZM59.6783 28.8213V31.0763H65.0758C64.9145 32.3451 64.492 33.2713 63.847 33.9163C63.062 34.7013 61.8333 35.5676 59.6783 35.5676C56.3558 35.5676 53.7583 32.8888 53.7583 29.5663C53.7583 26.2438 56.3558 23.5651 59.6783 23.5651C61.4708 23.5651 62.7795 24.2701 63.7458 25.1763L65.337 23.5851C63.9883 22.2963 62.1958 21.3101 59.6783 21.3101C55.127 21.3101 51.3008 25.0151 51.3008 29.5663C51.3008 34.1176 55.127 37.8226 59.6783 37.8226C62.1358 37.8226 63.9883 37.0176 65.4383 35.5063C66.9283 34.0163 67.392 31.9213 67.392 30.2301C67.392 29.7063 67.352 29.2226 67.2708 28.8201H59.6783V28.8213ZM116.313 30.5726C115.871 29.3838 114.521 27.1901 111.762 27.1901C109.023 27.1901 106.748 29.3451 106.748 32.5063C106.748 35.4863 109.003 37.8226 112.025 37.8226C114.461 37.8226 115.871 36.3326 116.455 35.4663L114.642 34.2576C114.038 35.1438 113.212 35.7276 112.025 35.7276C110.836 35.7276 109.991 35.1838 109.447 34.1163L116.556 31.1763L116.313 30.5726ZM109.063 32.3451C109.003 30.2913 110.655 29.2438 111.842 29.2438C112.768 29.2438 113.553 29.7063 113.816 30.3713L109.063 32.3451ZM103.285 37.5001H105.621V21.8738H103.285V37.5001ZM99.457 28.3776H99.377C98.8533 27.7538 97.847 27.1901 96.5783 27.1901C93.9195 27.1901 91.4833 29.5263 91.4833 32.5263C91.4833 35.5063 93.9195 37.8226 96.5783 37.8226C97.847 37.8226 98.8533 37.2588 99.377 36.6138H99.457V37.3788C99.457 39.4126 98.3695 40.5001 96.617 40.5001C95.187 40.5001 94.3008 39.4726 93.9383 38.6076L91.9045 39.4538C92.4883 40.8638 94.0395 42.5951 96.617 42.5951C99.3558 42.5951 101.672 40.9838 101.672 37.0576V27.5126H99.457V28.3776ZM96.7795 35.7276C95.1683 35.7276 93.8195 34.3788 93.8195 32.5251C93.8195 30.6526 95.1683 29.2826 96.7795 29.2826C98.3708 29.2826 99.6195 30.6513 99.6195 32.5251C99.6183 34.3788 98.3708 35.7276 96.7795 35.7276ZM127.256 21.8738H121.667V37.5001H124V31.5801H127.257C129.842 31.5801 132.383 29.7088 132.383 26.7276C132.383 23.7463 129.841 21.8738 127.256 21.8738ZM127.316 29.4051H123.998V24.0488H127.316C129.06 24.0488 130.05 25.4926 130.05 26.7276C130.05 27.9376 129.06 29.4051 127.316 29.4051ZM141.731 27.1613C140.042 27.1613 138.293 27.9051 137.57 29.5538L139.641 30.4188C140.083 29.5538 140.907 29.2726 141.772 29.2726C142.978 29.2726 144.205 29.9963 144.225 31.2826V31.4438C143.802 31.2026 142.897 30.8401 141.792 30.8401C139.561 30.8401 137.288 32.0663 137.288 34.3588C137.288 36.4501 139.118 37.7963 141.168 37.7963C142.737 37.7963 143.601 37.0926 144.143 36.2688H144.223V37.4751H146.475V31.4838C146.475 28.7088 144.405 27.1613 141.731 27.1613ZM141.45 35.7251C140.686 35.7251 139.62 35.3426 139.62 34.3976C139.62 33.1913 140.947 32.7288 142.092 32.7288C143.117 32.7288 143.6 32.9501 144.223 33.2513C144.042 34.7001 142.796 35.7251 141.45 35.7251ZM154.677 27.5026L152.003 34.2776H151.923L149.15 27.5026H146.637L150.798 36.9713L148.426 42.2388H150.858L157.272 27.5026H154.677ZM133.668 37.5001H136.001V21.8738H133.668V37.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0436 9.4223C12.6798 9.8073 12.4648 10.4048 12.4648 11.1786V38.8236C12.4648 39.5986 12.6798 40.1948 13.0436 40.5798L13.1361 40.6698L28.6223 25.1836V25.0011V24.8186L13.1361 9.33105L13.0436 9.4223Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7863 30.3475L28.625 25.1837V25.0012V24.8187L33.7875 19.6562L33.9038 19.7225L40.02 23.1975C41.7675 24.19 41.7675 25.8137 40.02 26.8075L33.9038 30.2825L33.7863 30.3475Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9017 30.281L28.623 25.001L13.043 40.5797C13.6192 41.1897 14.5692 41.2647 15.6405 40.656L33.9017 30.281Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9005 19.721L15.6405 9.346C14.5692 8.73725 13.6192 8.81351 13.043 9.42226L28.6217 25.001L33.9005 19.721Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.7842 30.165L15.6405 40.4738C14.6255 41.05 13.718 41.0125 13.1355 40.4875L13.043 40.5813L13.1355 40.6713C13.718 41.1963 14.6255 41.235 15.6405 40.6575L33.9005 30.2825L33.7842 30.165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M13.0436 40.3974C12.6798 40.0124 12.4648 39.4149 12.4648 38.6411V38.8236C12.4648 39.5974 12.6798 40.1949 13.0436 40.5799L13.1361 40.4861L13.0436 40.3974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M40.0177 26.6237L33.7852 30.1649L33.9014 30.2812L40.0177 26.8062C40.8914 26.3099 41.3277 25.6562 41.3277 25.0024C41.2539 25.5937 40.8089 26.1737 40.0177 26.6237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.6411 9.52863L40.0173 23.3786C40.8098 23.8286 41.2536 24.4086 41.3273 25.0011C41.3273 24.3474 40.8911 23.6924 40.0173 23.1961L15.6411 9.34613C13.8936 8.35363 12.4648 9.17738 12.4648 11.1786V11.3611C12.4648 9.36113 13.8936 8.53613 15.6411 9.52863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6439 17.8417H51.7227V15.328H52.4564C53.1052 14.7692 53.4227 13.813 53.4102 12.458V8.75049H58.4177V15.3292H59.2552V17.843H58.3339V16.2505H52.6452V17.8417H52.6439ZM54.3727 12.4592C54.3877 13.6455 54.1489 14.603 53.6614 15.3292H57.4527V9.67299H54.3727V12.4592Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7717 15.2815C66.0342 16.0403 65.118 16.4178 64.0217 16.4178C62.9255 16.4178 62.0092 16.039 61.273 15.2815C60.5355 14.524 60.168 13.5965 60.168 12.5003C60.168 11.404 60.5355 10.4765 61.273 9.71904C62.0092 8.96029 62.9255 8.58154 64.0217 8.58154C65.1117 8.58154 66.0267 8.96279 66.7667 9.72404C67.5067 10.4853 67.8767 11.4103 67.8767 12.5003C67.8755 13.5965 67.5067 14.524 66.7717 15.2815ZM61.983 14.6528C62.538 15.2153 63.2167 15.4953 64.0205 15.4953C64.823 15.4953 65.5042 15.214 66.058 14.6528C66.613 14.0903 66.8917 13.3728 66.8917 12.5003C66.8917 11.6278 66.613 10.9103 66.058 10.3478C65.5042 9.78529 64.8242 9.50529 64.0205 9.50529C63.2167 9.50529 62.538 9.78654 61.983 10.3478C61.4292 10.9103 61.1505 11.6278 61.1505 12.5003C61.1505 13.3728 61.4292 14.0903 61.983 14.6528Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7244 16.418C71.6206 16.418 70.6956 16.0443 69.9481 15.298C69.2006 14.5505 68.8281 13.618 68.8281 12.5005C68.8281 11.383 69.2006 10.4505 69.9494 9.70426C70.6969 8.95676 71.6219 8.58301 72.7256 8.58301C73.8556 8.58301 74.7756 8.99176 75.4806 9.80926L74.8094 10.4593C74.3006 9.82301 73.6044 9.50551 72.7256 9.50551C71.9081 9.50551 71.2181 9.78176 70.6569 10.333C70.0944 10.8843 69.8131 11.608 69.8131 12.5005C69.8131 13.393 70.0944 14.118 70.6569 14.668C71.2181 15.2193 71.9081 15.4955 72.7256 15.4955C73.6269 15.4955 74.3944 15.133 75.0306 14.4068L75.7006 15.0768C75.3581 15.4893 74.9294 15.8155 74.4119 16.0555C73.8944 16.298 73.3319 16.418 72.7244 16.418Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5978 16.2505H78.6341V9.67174H76.5391V8.75049H81.6928V9.67174H79.5978V16.2505Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3086 8.75049L85.4698 15.078C85.0786 15.9717 84.4961 16.418 83.7211 16.418C83.4898 16.418 83.2423 16.363 82.9761 16.2505L83.2273 15.3605C83.3886 15.4517 83.5561 15.4967 83.7298 15.4967C83.9536 15.4967 84.1261 15.453 84.2486 15.3667C84.3711 15.2792 84.4836 15.1205 84.5886 14.8905L84.8611 14.293L82.3398 8.75049H83.4711L85.3248 13.0555H85.3661L87.1773 8.75049H88.3086Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4023 16.2505V8.75049H94.8286V16.2505H93.8648V9.67174H90.3648V16.2505H89.4023Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.543 16.2505V8.75049H97.5067V11.9655H101.257V8.75049H102.22V16.2505H101.257V12.8667H97.5067V16.2505H96.543Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.072 15.2815C109.335 16.0403 108.419 16.4178 107.322 16.4178C106.226 16.4178 105.31 16.039 104.574 15.2815C103.836 14.524 103.469 13.5965 103.469 12.5003C103.469 11.404 103.836 10.4765 104.574 9.71904C105.31 8.96029 106.226 8.58154 107.322 8.58154C108.412 8.58154 109.327 8.96279 110.067 9.72404C110.807 10.4853 111.177 11.4103 111.177 12.5003C111.176 13.5965 110.807 14.524 110.072 15.2815ZM105.285 14.6528C105.84 15.2153 106.519 15.4953 107.322 15.4953C108.126 15.4953 108.806 15.214 109.36 14.6528C109.915 14.0903 110.194 13.3728 110.194 12.5003C110.194 11.6278 109.915 10.9103 109.36 10.3478C108.806 9.78529 108.126 9.50529 107.322 9.50529C106.519 9.50529 105.84 9.78654 105.285 10.3478C104.731 10.9103 104.452 11.6278 104.452 12.5003C104.452 13.3728 104.73 14.0903 105.285 14.6528Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.117 16.2505V8.75049H117.83C118.417 8.75049 118.925 8.94424 119.355 9.33174C119.785 9.72049 120 10.2067 120 10.793C120 11.1492 119.907 11.4642 119.721 11.7355C119.537 12.008 119.29 12.2142 118.982 12.3542V12.3955C119.352 12.5217 119.656 12.738 119.893 13.0442C120.13 13.3517 120.25 13.708 120.25 14.113C120.25 14.728 120.023 15.2367 119.573 15.6417C119.123 16.0467 118.591 16.2492 117.976 16.2492H115.117V16.2505ZM116.08 11.9655H117.828C118.192 11.9655 118.483 11.8455 118.703 11.6042C118.923 11.3642 119.033 11.1005 119.033 10.8142C119.033 10.528 118.927 10.2655 118.713 10.0292C118.501 9.79174 118.22 9.67299 117.871 9.67299H116.078V11.9655H116.08ZM116.08 15.3292H118.018C118.388 15.3292 118.688 15.2005 118.92 14.9405C119.151 14.683 119.265 14.3992 119.265 14.0917C119.265 13.7842 119.146 13.5042 118.908 13.2492C118.672 12.9942 118.361 12.8667 117.976 12.8667H116.08V15.3292Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27.2495,
    y1: 10.8869,
    x2: 6.27147,
    y2: 31.8649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 42.2943,
    y1: 25.0017,
    x2: 12.0481,
    y2: 25.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 31.033,
    y1: 27.8699,
    x2: 2.5851,
    y2: 56.3177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.11959,
    y1: 0.220005,
    x2: 21.8228,
    y2: 12.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168.75,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayButton);
export default __webpack_public_path__ + "static/media/google_play_button.3b116184308ed083ad997dc79897f2aa.svg";
export { ForwardRef as ReactComponent };